import { defineComponent as s, useCssModule as t, openBlock as r, createBlock as o, resolveDynamicComponent as a, normalizeClass as l, withCtx as n, renderSlot as d } from "vue";
import c from "./styles/CdrCard.module.scss.mjs";
import p from "../../../_virtual/_plugin-vue_export-helper.mjs";
const u = s({
  name: "CdrCard",
  props: {
    /**
     * Sets valid HTML container element tag.
     */
    tag: {
      type: String,
      default: "article"
    }
  },
  setup() {
    return {
      style: t(),
      baseClass: "cdr-card"
    };
  }
});
function f(e, m, C, _, y, $) {
  return r(), o(a(e.tag), {
    class: l(e.style[e.baseClass])
  }, {
    default: n(() => [d(e.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
const i = {
  $style: c
}, h = /* @__PURE__ */ p(u, [["render", f], ["__cssModules", i]]);
export {
  h as default
};
